import { TransactionDetailResponse } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { TransactionType } from '@finxone-platform/shared/sys-config-types';
import { Observable, of } from 'rxjs';

export class MockTransactionService {
  constructor() {}

  public getTransactionDetailById(
    transactionNumber: string,
    transactionId: string,
    transactionType: TransactionType,
  ): Observable<TransactionDetailResponse> {
    return of({
      currency: 'GBP',
      amount: 150,
      id: 'P2100DYH8X',
      dateOfTransaction: '2023-11-30T07:00:38.038+0000',
      reference: 'P2100DYH8X',
      createdAt: '2024-01-11T16:04:15.317Z',
      paymentReference: 'January rent',
      sender: {
        accountNumber: '12345678',
        name: 'Anne Miller',
        sortCode: '000000',
      },
      receiver: {
        accountNumber: '12345678',
        sortCode: '000000',
        name: 'Brandon Taylor',
      },
      type: 'credit',
      status: 'success',
      feeAmount: 12,
      feeCurrency: 'GBP',
      totalAmount: 13,
    });
  }
}
